import { render, staticRenderFns } from "./AntiCrawlerChallenge.vue?vue&type=template&id=019fa694&scoped=true"
import script from "./AntiCrawlerChallenge.vue?vue&type=script&lang=js"
export * from "./AntiCrawlerChallenge.vue?vue&type=script&lang=js"
import style0 from "./AntiCrawlerChallenge.vue?vue&type=style&index=0&id=019fa694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019fa694",
  null
  
)

export default component.exports